
export class EpbtFaQuickPurchaseProductQtyEntryLine {
    // constructor(line: EpbtFaQuickPurchaseLineModel) {
    // constructor(line: any) {
    //     this.product = line.product;
    //     this.quantity = line.quantity;
    //     this.tally = line.tally;
    //     this.quantityTally = line.quantityTally;
    //     this.inputPer = line.inputPer;
    //     this.tallyLengthsFormatted = line.product.tallyLengths ? line.product.tallyLengths : "";
    // }

    // isTallyLine?: boolean | undefined;
    // tally?: EpbtFaTallyModel | undefined;
    // quantityTally?: string | undefined;
    // product?: Product2 | undefined;
    // inputPer?: Per | undefined;
    // quantity?: number | undefined;
    // inputPerID?: number | undefined;
    // tallyLengthsFormatted?: string | undefined;
}
